import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {AnalysisVisualizationType} from 'analysis-tool/ui/charting/ChartingTypes';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {VisualizationType} from 'insights/analytics-visualizations/AnalyticsVisualizationTypes';
import {assertPipelineStepIsStepType, PipelineStep} from 'pipelines/PipelineTypes';
import {getPipelineStepConfig} from 'pipelines/StepShapeUtils';
import {BenchlingDuotoneIconName} from 'ui-library/icons/BenchlingDuotoneIcon';

import {
  getAnalysisOnlyChartViewTypes,
  ANALYSIS_VISUALIZATION_TYPE_TO_ICON,
} from './AnalysisChartingConstants';

export function getIconAndTextForChartViewStep(chartViewStep: GetAnalysisPipelineStep): {
  icon: BenchlingDuotoneIconName;
  title: string;
} {
  const config = getPipelineStepConfig(chartViewStep, PipelineStepType.CHART_VIEW, 0);
  return {icon: ANALYSIS_VISUALIZATION_TYPE_TO_ICON[config.chartConfig.type], title: config.chartName};
}

export function getIconAndTextForTableViewStep(chartViewStep: GetAnalysisPipelineStep): {
  icon: BenchlingDuotoneIconName;
  title: string;
} {
  const config = getPipelineStepConfig(chartViewStep, PipelineStepType.TABLE_VIEW, 0);
  return {icon: 'table', title: config.viewName};
}

export function getIconAndTextForRegressionStep(regressionStep: GetAnalysisPipelineStep): {
  icon: BenchlingDuotoneIconName;
  title: string;
} {
  const config =
    regressionStep.config != null
      ? getPipelineStepConfig(regressionStep, PipelineStepType.REGRESSION, 0)
      : null;
  return {
    icon: ANALYSIS_VISUALIZATION_TYPE_TO_ICON[AnalysisVisualizationType.SCATTER_PLOT],
    title: config?.name ?? 'Regression',
  };
}

export function isAnalysisOnlyChartStep(step: PipelineStep): boolean {
  if (step.stepType !== PipelineStepType.CHART_VIEW) {
    return false;
  }
  assertPipelineStepIsStepType(PipelineStepType.CHART_VIEW, 0, step);
  if (step.config == null) {
    return false;
  }
  return getAnalysisOnlyChartViewTypes().includes(step.config.chartConfig.type as AnalysisVisualizationType);
}

export function isNotAnalysisOnlyChartConfig(configType: string): configType is VisualizationType {
  return !getAnalysisOnlyChartViewTypes().includes(configType as AnalysisVisualizationType);
}

export function isAnalysisOnlyLegacyChartStep(step: GetAnalysisPipelineStep): boolean {
  if (step.definition.stepType !== PipelineStepType.CHART_VIEW) {
    return false;
  }
  if (step.config == null) {
    return false;
  }

  const config = getPipelineStepConfig(step, PipelineStepType.CHART_VIEW, 0);
  return getAnalysisOnlyChartViewTypes().includes(config.chartConfig.type as AnalysisVisualizationType);
}
